export default __webpack_public_path__ + "static/media/CarImages.SorentoMedium1.88e09a50.jpg";